'use client';

import type { ConsentService } from './consent.types';
import { ConsentToggle } from './ConsentToggle';

/** Project palette — the only lines that differ between the sibling projects. */
const CLS = {
    label: 'text-sm font-medium text-white',
    description: 'mt-0.5 text-sm text-white/60',
};

type Props = {
    service: ConsentService;
    checked: boolean;
    /** Services of a required category are shown as permanently on. */
    disabled: boolean;
    onChange: (checked: boolean) => void;
    toggleId: string;
};

/** One technology inside a category, with its own switch. */
export function ConsentServiceItem({ service, checked, disabled, onChange, toggleId }: Props) {
    return (
        <li className="flex items-start justify-between gap-4 py-3">
            <div className="min-w-0">
                <label htmlFor={toggleId} className={CLS.label}>
                    {service.label}
                </label>
                <p className={CLS.description}>{service.description}</p>
            </div>

            <ConsentToggle
                id={toggleId}
                checked={checked}
                disabled={disabled}
                label={`${service.label} erlauben`}
                onChange={onChange}
            />
        </li>
    );
}
